import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { typedFetch } from '../../typedFetch';
import './Departments.scss';
export const Departments = ({ appendToErrorLog, loggedInUser, }) => {
    const [loading, setLoading] = useState(true);
    const [departments, setDepartments] = useState([]);
    useEffect(() => {
        if (!loggedInUser) {
            appendToErrorLog('Only logged-in users may see the list of departments');
            setLoading(false);
            return;
        }
        typedFetch('departments', {
            body: { action: 'getWithStats' },
        })
            .then((result) => {
            if (result.success) {
                setDepartments(result.departmentsWithStats);
            }
            else {
                appendToErrorLog(`Failed to retrieve list of departments: ${result.reason}`);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while retrieving list of departments: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [loggedInUser, appendToErrorLog]);
    const [addDepartmentValue, setAddDepartmentValue] = useState('');
    const deleteDepartment = (departmentName) => () => {
        if (loading) {
            return;
        }
        setLoading(true);
        typedFetch('departments', {
            body: {
                action: 'delete',
                deleteDepartmentName: departmentName,
            },
        })
            .then((result) => {
            if (result.success) {
                setDepartments(result.departmentsWithStats);
            }
            else {
                appendToErrorLog(`Failed to delete department: ${result.reason}`);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while deleting department: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const addDepartment = () => {
        if (loading) {
            return;
        }
        setLoading(true);
        typedFetch('departments', {
            body: {
                action: 'add',
                addDepartmentName: addDepartmentValue,
            },
        })
            .then((result) => {
            if (result.success) {
                setDepartments(result.departmentsWithStats);
                setAddDepartmentValue('');
            }
            else {
                appendToErrorLog(`Failed to add department: ${result.reason}`);
            }
        })
            .catch((error) => {
            appendToErrorLog(`Unexpected error while adding department: ${String(error['message'])}`);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (loading) {
        return 'Processing...';
    }
    if (!loggedInUser) {
        return 'No departments to display';
    }
    return (_jsxs("main", { className: "departments", children: [loggedInUser.supervisor ? (_jsxs("div", { className: "add", children: [_jsx("button", { disabled: addDepartmentValue === '', onClick: addDepartment, children: "Add Department" }), _jsx("input", { value: addDepartmentValue, onChange: (e) => { setAddDepartmentValue(e.currentTarget.value); } })] })) : null, _jsxs("div", { children: [_jsxs("div", { className: "row", children: [_jsx("div", { children: "Name" }), _jsx("div", { children: "Tickets" }), _jsx("div", { children: "Open tickets" }), _jsx("div", { children: "Workers" }), _jsx("div", { title: "Only takes tickets that are already Completed or Verified into account. Excludes scheduled tickets.", children: "Median completion time" }), _jsx("div", {})] }), departments.map(department => (_jsxs("div", { className: "row", children: [_jsx("div", { children: department.name }), _jsx("div", { children: _jsx("a", { href: `/tickets?departments=${department.name.toLowerCase()}`, children: department.ticketCount }) }), _jsx("div", { children: _jsx("a", { href: `/tickets?departments=${department.name.toLowerCase()}&status=submitted|accepted|in-progress|work-not-accepted`, children: department.openCount }) }), _jsx("div", { children: department.workerCount }), _jsx("div", { children: `${department.medianHoursToCompletion} hours` }), _jsx("div", { children: loggedInUser.supervisor && department.ticketCount === 0
                                    ? _jsx("button", { onClick: deleteDepartment(department.name), children: "Delete" })
                                    : `${department.ticketCount} ticket${department.ticketCount === 1 ? '' : 's'}` })] }, department.name))), departments.length === 0 && 'No departments to display'] })] }));
};
